// @ts-nocheck
import { useState, useEffect, useRef } from "react";
import { Button, Input, Form, Select, Flex } from 'antd';


function base64urlEncode(data: any) {
  return btoa(String.fromCharCode(...new Uint8Array(data)))
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
}


const base64urlEncodeJSON = (obj: any) => {
  return base64urlEncode(new TextEncoder().encode(JSON.stringify(obj)));
}


const base64urlDecode = (str: any) => {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  const pad = str.length % 4 ? 4 - (str.length % 4) : 0;
  const base64 = str + "=".repeat(pad);
  const bin = atob(base64);

  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
}


async function verifyJwt(token: any, secret: any) {
  let errors = [];
  let payload;
  const [headerB64, payloadB64, signatureB64 = ""] = token.split(".");
  if (!headerB64 || !payloadB64) throw new Error("Invalid JWT format");
  const header = JSON.parse(new TextDecoder().decode(base64urlDecode(headerB64)));

  if (header.alg === "none") {
    if (signatureB64 !== "") {
      errors.push("Unexpected signature for alg=none");
    }
    payload = JSON.parse(new TextDecoder().decode(base64urlDecode(payloadB64)));
    if (payload.exp && Date.now() / 1000 > payload.exp) {
      errors.push("Token expired");
    }
  } else {
    const alg = `SHA-${header.alg.substring(2)}`;
    const data = `${headerB64}.${payloadB64}`;
    const key = await crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(secret),
      { name: "HMAC", hash: { name: alg } },
      false,
      ["verify"]
    );

    const signature = base64urlDecode(signatureB64);
    const valid = await crypto.subtle.verify("HMAC", key, signature, new TextEncoder().encode(data));
    if (!valid) {
      errors.push("Invalid signature");
    }

    payload = JSON.parse(new TextDecoder().decode(base64urlDecode(payloadB64)));
    if (payload.exp && Date.now() / 1000 > payload.exp) {
      errors.push("Token expired");
    }
  }
  return { errors, payload, algorithm: header.alg };
}


async function signData(algorithm: any, data: any, secret: any) {
  const enc = new TextEncoder();
  const dataBuffer = enc.encode(data);
  if (algorithm === "none") {
    return "";
  }

  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(secret),
    { name: "HMAC", hash: { name: algorithm } },
    false,
    ["sign"]
  );
  const signature = await crypto.subtle.sign("HMAC", key, dataBuffer);
  return base64urlEncode(signature);

}


async function createToken(payload: any, secret: any, options: any = {}) {
  const alg = options.algorithm || "SHA-256";
  const header = {
    alg: alg !== "none" ? `HS${alg.split("-")[1]}` : alg,
    typ: "JWT"
  };

  if (options.expiresIn) {
    const now = Math.floor(Date.now() / 1000);
    payload = { ...payload, exp: now + options.expiresIn };
  }

  const headerEncoded = base64urlEncodeJSON(header);
  const payloadEncoded = base64urlEncodeJSON(payload);
  const data = `${headerEncoded}.${payloadEncoded}`;

  const signatureEncoded = await signData(alg, data, secret);
  return `${data}.${signatureEncoded}`.substring(0, 30);
}

const jsonStringify = (obj: any, pretty: any) => {
  return JSON.stringify(obj, (_, value) => {
    if (typeof value === "bigint") {
      return value.toString() + "n";
    }
    return value;
  }, pretty ? 2 : 0);
};



const JwtToken0 = () => {
  const [formCreate] = Form.useForm();
  const [formVerify] = Form.useForm();
  const [jwtToken, setJwtToken] = useState("");
  const [decodedJwtToken, setDecodedJwtToken] = useState("");
  const [decodeErrors, setDecodeErrors] = useState(null);
  const [decodeAlgo, setDecodeAlgo] = useState("");
  
  const { TextArea } = Input;

  useEffect(() => {
    setDecodedJwtToken("");
    setDecodeAlgo("");
    setDecodeErrors(null);
  }, [jwtToken]);

  const create = async (values: any) => {
    let payload;
    try {
      payload = JSON.parse(values.payload);
    } catch (e) {
      throw e
      return;
    }
    console.log("Token created")
    const jwt = await createToken(payload, values.secret, {
      expiresIn: Number(values.expiresIn),
      algorithm: values.algo
    });
    // formVerify.setFieldsValue({
    //   jwtToken: jwt
    // });
    setJwtToken(jwt);
  };

  const verify = async (values: any) => {
    const secret = formCreate.getFieldValue("secret");
    if (!secret) {

      return;
    }
    if (!values.jwtToken) {

      return;
    }
    setDecodedJwtToken("");
    setDecodeAlgo("");
    setDecodeErrors(null);
    try {
      const v = await verifyJwt(values.jwtToken, secret);
      setDecodedJwtToken(JSON.stringify(v.payload, null, 2));
      setDecodeAlgo(v.algorithm);
      // setDecodeErrors(v.errors);
    } catch (e) {
    }
  };

  return (
    <div className="h-full overflow-auto">
      <h2 style={{marginBottom: '20px', marginTop:'50px'}}>
        This page creates a signed token
      </h2>
      <Form
        form={formCreate}
        onFinish={create}
        layout="vertical"
        initialValues={{
          secret: "random",
          expiresIn: "3600",
          payload: '{"userId":12}',
          algo: "SHA-256"
        }}
      >

        <div style={{ height: 0, overflow: "hidden" }}>
          <Form.Item
            name="secret"
            label="Secret Key"
            rules={[{ required: true, message: "Set a secret key" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="payload">
            <TextArea


            />
          </Form.Item>
          <Flex className="mt-15!" gap="large">
            <Form.Item
              name="expiresIn"
              label="Expires In"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="algo"
              label="Sign Algorithm"
            >
              <Select options={[
                { value: "SHA-256", label: "HS256" },
                { value: "SHA-384", label: "HS384" },
                { value: "SHA-512", label: "HS512" },
                { value: "none", label: "None" },
              ]} />
            </Form.Item>
          </Flex>
        </div>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create Token
          </Button>
        </Form.Item>
        <Button onClick={()=>setJwtToken(cur => `Current: ${cur}`)}>
            Read token from state
          </Button>
      </Form>
      {/* <div style={{marginTop:'30px'}}>{jwtToken.startsWith("Current") ? jwtToken.substring(0, 39) : jwtToken.substring(0, 30)}</div> */}
      <div style={{marginTop:'30px'}}>{jwtToken}</div>
      {/* <div>
        <Form
          form={formVerify}
          onFinish={verify}
          onValuesChange={(values) => {
            setJwtToken(values.jwtToken);
          }}
          layout="vertical"
        >
          <Form.Item
            name="jwtToken"
            label="JWT Token"
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Verify JWT Token
            </Button>
          </Form.Item>
        </Form>
      </div> */}
      <div>
        {/* {decodeErrors !== null && (
          decodeErrors.length > 0 ? (
            decodeErrors.map((e, i) => (
              <span key={i} className="text-error">{e}</span>
            ))
          ) : <span key="valid" className="text-success">The JWT Token is valid</span>
        )} */}
        {decodeAlgo && (
          <div>Algorithm: {decodeAlgo}</div>
        )}

        {/* <TextArea value={decodedJwtToken} /> */}
      </div>
    </div>

  );
}


// const Jwt = () => {
//   const tabsRef = useRef();

//   const addTab = () => {
//     if (tabsRef.current) {
//       tabsRef.current.addTab(
//         <JwtTab />
//       );
//     }
//   };

//   useEffect(() => {
//     addTab();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);


//   return (
//     <DynamicTabs
//       ref={tabsRef}
//       label="Jwt"
//       hideAdd={false}
//       onAddTabRequest={() => {
//         addTab();
//       }}
//       noDataHelper={
//         <Button className="mt-10" type="primary" onClick={addTab}>
//           New JWT Tool
//         </Button>
//       }
//     />
//   );

// }


















function makeNestedHandler(finalFn, depth = 10) {
  // genera una lista di funzioni anonime annidate
  const chain = [];
  const ff = () => {
    finalFn();
    for (let i = 0; i < 50000; i++) {
      Math.sqrt(i);
    }
  }
  for (let i = 0; i < depth; i++) {
    chain.push(function level() {
      return chain[i + 1] ? chain[i + 1]() : ff();
    });
  }

  // ritorna il primo livello come handler annidato
  return chain[0];
}






function JwtToken1() {
  const [log, setLog] = useState([]);

  const addLog = (msg) => setLog((l) => [...l, msg]);

  const runSync = () => {
    const x = { foo: 1 };
    window.__bdhs_object = x;
    addLog("Sync test executed");
  };

  const runNested = () => {
    function A() {

      B();
    }
    function B() {
      const x = { foo: 2 };
      window.__bdhs_object = x;
    }
    A();
    addLog("Nested sync test executed");
  };

  const runAwait = async () => {
    await Promise.resolve();
    const x = { foo: 3 };
    window.__bdhs_object = x;
    addLog("Await test executed");
  };

  const runThen = () => {
    Promise.resolve().then(() => {
      const x = { foo: 4 };
      window.__bdhs_object = x;
      addLog("Promise.then test executed");
    });
  };

  // cascade return test
  const runCascade = () => {
    function A() {
      return B();
    }
    function B() {
      return C();
    }
    function C() {
      const x = { foo: 5 };
      window.__bdhs_object = x;
    }
    A();
    addLog("Cascade return test executed");
  };

  //   // nested async + sync
  //   const runNestedAsyncSync = async () => {
  //     await Promise.resolve();
  //     function inner() {
  //       const x = { foo: 6 };
  //       window.__bdhs_object = x;
  //     }
  //     inner();
  //     addLog("Nested async + sync test executed");
  //   };
  //   window.__bdhs_object = x;
  //   addLog("Promise.then test executed");
  // }


  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-bold">BDHS Manual Tests</h1>
      <div className="space-y-2">
        <button onClick={makeNestedHandler(runSync)} className="px-3 py-2 bg-blue-500 rounded">Sync</button>
        <button onClick={makeNestedHandler(runNested)} className="px-3 py-2 bg-green-500 rounded">Nested Sync</button>
        <button onClick={makeNestedHandler(runAwait)} className="px-3 py-2 bg-purple-500 rounded">Await</button>
        <button onClick={makeNestedHandler(runThen)} className="px-3 py-2 bg-orange-500 rounded">Promise.then</button>
        <button onClick={makeNestedHandler(runCascade)} className="px-3 py-2 bg-red-500 rounded">Cascade Return</button>
        <button onClick={runCascade} className="px-3 py-2 bg-red-500 rounded">Cascade Return222</button>
        {/* <button onClick={runNestedAsyncSync} className="px-3 py-2 bg-teal-600 text-white rounded">Nested Async+Sync</button> */}
      </div>

      <div className="mt-4 p-3 border rounded bg-gray-100 h-40 overflow-auto text-sm">
        {log.map((l, i) => (
          <div key={i}>{l}</div>
        ))}
      </div>
    </div>
  );
}


const JwtToken = () => {
  return (
    <div>
      <JwtToken0 />
      {/* <JwtToken1 /> */}
    </div>
  )
}




export default JwtToken;